import {ValueDefinition} from '@/model/types';

export const enum RequestType {
  NEW_PLAN = 'DV-4#0',
  EXISTING_PLAN = 'DV-4#1',
}

export const DV_4 = {
  id: 'DV-4',
  description: {
    fr: 'Type de demande',
    en: 'Request type',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Nouveau régime',
        en: 'New plan',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Régime existant',
        en: 'Existing plan',
      },
    },
  ],
} as const satisfies ValueDefinition;
